import AppListing from '../app-components/Listing/AppListing';

Vue.component('book-listing', {
    mixins: [AppListing]
});